// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MyYU","index":"styles_index__3ZQHu"};